import React from "react";
import { Box, Grid, styledContainer, styled } from "@mui/material";
import { Link } from "react-router-dom";

// Image Imports
import imagePathImg1 from "../assets/cccu-logo-ByJplg9N.webp";
import imagePathImg2 from "../assets/apex-logo-BvJhEk40.webp";
import imagePathImg3 from "../assets/lsst-CjRzljOX.png";
import imagePathImg4 from "../assets/uor-logo-CoS-nrVF.webp";

/**
 * Styled Components (Const styling style)
 * We use 'styled' from MUI to keep the JSX clean.
 */

const MainWrapper = styled("div")({
    width: "100%",
    padding: "20px 0",
});

const Title = styled(Box)({
    textAlign: "center",
    maxWidth: 500,
    color: "#333", // Darker text since background is now transparent/none
    margin: "0 auto 30px auto",
    fontWeight: "600",
    fontSize: "1.2rem",
});

const LogoContainer = styled(Box)({
    textAlign: "center", // Centers the group of inline-block elements
    width: "100%",
});

const ResponsiveItem = styled(Box)(({ theme }) => ({
    // Inline-block allows items to sit side-by-side but wrap like text on small screens
    display: "inline-block",
    verticalAlign: "middle",
    padding: "15px",
    // Responsive sizing: 45% width on mobile (2 per row), 22% on desktop (4 per row)
    width: "45%",
    [theme.breakpoints.up("sm")]: {
        width: "22%",
    },
}));

const LogoImage = styled("img")({
    maxWidth: "100%",
    height: "auto",
    transition: "transform 0.3s ease",
    "&:hover": {
        transform: "scale(1.08)",
    },
});

function PartnerSchools() {
    // Data array for cleaner mapping
    const partners = [
        { src: imagePathImg1, alt: "CCCU", path: "/canterbury-christ-church-university" },
        { src: imagePathImg2, alt: "Apex", path: "/apex-college" },
        { src: imagePathImg3, alt: "LSST", path: "/london-school-science-technology" },
        { src: imagePathImg4, alt: "Roehampton", path: "/roehampton" },
    ];

    return (
        <MainWrapper>
            <Title>Partner Universities</Title>

            <LogoContainer>
                {partners.map((partner, index) => (
                    <ResponsiveItem key={index}>
                        <Link to={partner.path}>
                            <LogoImage
                                src={partner.src}
                                alt={partner.alt}
                                // Specific sizing for the Roehampton logo if it's naturally wider
                                style={partner.alt === "Roehampton" ? { maxWidth: "150px" } : { maxWidth: "110px" }}
                            />
                        </Link>
                    </ResponsiveItem>
                ))}
            </LogoContainer>
        </MainWrapper>
    );
}

export default PartnerSchools;
